// extracted by mini-css-extract-plugin
export default {"container":"ColorectalCancerScreening_container__iorgr","back-btn":"ColorectalCancerScreening_back-btn__6Po3L","back-icon":"ColorectalCancerScreening_back-icon__AS1DE"};